import { FC } from 'react';
import { SharedResourceTabs } from '@client/features/shared-resources/shared-resource-tabs';
import { WorkspaceLayoutsGrid } from './workspace-layouts-grid';

export type ManageWorkspaceLayoutsProps = {
  activeLayoutId?: string;
  onApply: (layoutId: string) => void;
  onDelete: (layoutIds: string[]) => void;
  onModify: (
    layoutId: string,
    layoutName: string,
    layoutNotes?: string
  ) => void;
  onSetDefault: (layoutId: string, isDefault: boolean) => void;
  onShare?: (layoutId: string, layoutName: string) => void;
  onImportShared: (
    sharedResourceId: string,
    sharedResourceName: string
  ) => void;
  onModifyShared: (
    sharedResourceId: string,
    sharedResourceName: string,
    sharedResourceNotes?: string
  ) => void;
  onRevokeShared: (sharedResourceId: string) => void;
};

export const ManageWorkspaceLayouts: FC<ManageWorkspaceLayoutsProps> = ({
  activeLayoutId,
  onApply,
  onDelete,
  onModify,
  onSetDefault,
  onShare,
  onImportShared,
  onModifyShared,
  onRevokeShared
}) => (
  <SharedResourceTabs
    sharedResourceType='workspaceLayout'
    onImportShared={onImportShared}
    onModifyShared={onModifyShared}
    onRevokeShared={onRevokeShared}
    renderMine={() => (
      <WorkspaceLayoutsGrid
        activeLayoutId={activeLayoutId}
        onApply={onApply}
        onDelete={onDelete}
        onModify={onModify}
        onSetDefault={onSetDefault}
        onShare={onShare}
      />
    )}
  />
);
